// extracted by mini-css-extract-plugin
export default {"rating":"oy-z","numberOfStars":"py-z","count":"qy-z","barGraphSpacing":"ry-z","barGraph":"sy-z"};